import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import '@/styles/globals.css';
import './styles/appearance.css';
// Import Leaflet CSS - required for the map to display correctly
import 'leaflet/dist/leaflet.css';
import { AuthProvider } from './contexts/AuthContext';
import PulseBootstrap from './contexts/PulseBootstrap';
import { AppearanceProvider } from './contexts/AppearanceContext';
import { registerSW } from './utils/registerSW';

// Register service worker for PWA (Vite uses import.meta.env.PROD)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  registerSW();
}

// Global diagnostics for runtime errors and unhandled promise rejections
// These help surface the root cause when Suspense/lazy boundaries swallow messages
if (typeof window !== 'undefined') {
  // Avoid double-registering in HMR
  if (!(window as any).__APP_DIAG_LISTENERS__) {
    (window as any).__APP_DIAG_LISTENERS__ = true;

    window.addEventListener('error', (event) => {
      try {
        const msg = event?.message || 'Unknown window error';
        const src = (event as any)?.filename || (event?.target as any)?.src || 'n/a';
        const line = (event as any)?.lineno;
        const col = (event as any)?.colno;
        const stack = (event as any)?.error?.stack || (event as any)?.error?.toString?.() || '';
        // eslint-disable-next-line no-console
        console.error('[Diagnostics][window.error]', { msg, src, line, col, stack });
      } catch {
        // ignore
      }
    });

    window.addEventListener('unhandledrejection', (event) => {
      try {
        const reason = (event as PromiseRejectionEvent)?.reason;
        const msg = typeof reason === 'string' ? reason : (reason?.message || 'Unhandled rejection');
        const stack = reason?.stack || '';
        // eslint-disable-next-line no-console
        console.error('[Diagnostics][unhandledrejection]', { msg, reason, stack });
      } catch {
        // ignore
      }
    });
  }
}

// Initialize React app
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <AppearanceProvider>
          <PulseBootstrap />
          <App />
        </AppearanceProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

